import React from "react";
import PropTypes from 'prop-types';

// Base
import ProgressBar from '../../../base/progress_bar';

export default class Progress extends React.Component {
  static propTypes = {
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    height: PropTypes.number,
  };

  static defaultProps = {
    height: 10,
  }

  render() {
    const { max, value, height } = this.props;

    return (
      <div className='width-550 flex flex-row margin-bottom-15'>
        <span className='semi-bold'>{value}/{max}</span>
        <span className="width-400 vertical-align margin-left-10">
          <ProgressBar {...{
            max,
            value,
            height,
            progressClassName: 'bg-primary-color',
          }} />
        </span>
      </div>
    )
  }
}